export default __webpack_public_path__ + "static/media/israel.d9a2971c.svg";